import { request } from './core'
import type { AnalysisResponse } from './types'

export const analysisApi = {
  getAnalysis: (slug: string) =>
    request<AnalysisResponse>(`/api/assessments/${slug}/analysis`),

  runAnalysis: (slug: string, revision?: number) =>
    request<{ status: string; revision?: number }>(
      `/api/assessments/${slug}/analysis`,
      { method: 'POST' },
      { ifMatch: revision },
    ),
}
